module.exports = __webpack_public_path__ + "img/light_armor_6.c49dae22.png";